export default "__VITE_ASSET__CRUIfSUD__"